import React, { useState, useEffect } from "react";
import { array, string } from "prop-types";
import { SectionHeading } from "../../atoms/SectionHeading";
import { SpeakerCard } from "../SpeakerCard";
import "./speakers-section.m.css";
import Confirmed from "../../../../assets/icons/confirmed";

export const SpeakersSection = ({ title, speakers = [], storyTemplate }) => {
  const [groupedSpeakers, setGroupedSpeakers] = useState([]);

  // Function to group speakers based on screen size
  const groupSpeakersResponsively = (speakerList) => {
    // Check if speakers is already grouped (array of arrays) or flat array
    const flatSpeakers = Array.isArray(speakerList[0]) && typeof speakerList[0][0] === 'object'
      ? speakerList.flat().sort((a, b) => a.name?.localeCompare(b.name) || 0)
      : speakerList.sort((a, b) => a.name?.localeCompare(b.name) || 0);

    if (!flatSpeakers || flatSpeakers.length === 0) return [];

    // Determine grouping based on window width
    let itemsPerRow = 5; // Desktop default

    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width >= 768 && width <= 1023) {
        itemsPerRow = 4; // Tablet
      } else if (width < 768) {
        itemsPerRow = 1; // Mobile
      }
    }

    const groups = [];
    for (let i = 0; i < flatSpeakers.length; i += itemsPerRow) {
      groups.push(flatSpeakers.slice(i, i + itemsPerRow));
    }

    return groups;
  };

  // Initial grouping and resize handler
  useEffect(() => {
    const updateGrouping = () => {
      setGroupedSpeakers(groupSpeakersResponsively(speakers));
    };

    // Initial grouping
    updateGrouping();

    // Add resize listener for responsive regrouping
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateGrouping);
      return () => window.removeEventListener('resize', updateGrouping);
    }
  }, [speakers]);

  return (
    <div styleName="speakers-section" data-section="speakers">
      <div styleName="section-header">
        <SectionHeading>{title}</SectionHeading>
        {storyTemplate !== "session" && <div styleName="hint">
          <div styleName="hint-icon">
            <Confirmed />
          </div>
          <div styleName="hint-text">
            <div>Confirmed</div>
          </div>
        </div>}
      </div>
      <div styleName="speaker-profiles">
        {groupedSpeakers.map((row, rowIndex) => (
          <div key={rowIndex} styleName="speakers-row">
            {row.map((speaker, index) => (
              <SpeakerCard
                key={index}
                name={speaker.name}
                designation={speaker.designation}
                company={speaker.company}
                imageUrl={speaker.imageUrl}
                isConfirmed={speaker.isConfirmed}
                linkedIn={speaker.linkedIn}
                description={speaker.description}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

SpeakersSection.propTypes = {
  title: string.isRequired,
  speakers: array,
};

